import React from "react";

interface CollapsibleProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  items: { text: string; onClick: () => void }[];
}

const Collapsible: React.FC<CollapsibleProps> = ({ title, items }) => {
  const [isOpen, setIsOpen] = React.useState(true);
  return (
    <>
      <div className="collapsible">
        <div className="header" onClick={() => setIsOpen(!isOpen)}>
          <div>{title}</div>
          <img
            style={{ width: 20, height: 20 }}
            src={isOpen ? "/minus.svg" : "/plus.svg"}
          />
        </div>
        {isOpen && (
          <div className="content">
            {items.map((item) => {
              return (
                <div className="item" onClick={item.onClick} key={item.text}>
                  {item.text}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <style jsx>{`
        .collapsible {
          width: 100%;

          .header {
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            color: #191919;

            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            letter-spacing: -0.28px;
          }

          .item {
            height: 48px;
            display: flex;
            align-items: center;
            padding-left: 20px;

            color: #666;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            letter-spacing: -0.28px;
          }
        }
        @media (max-width: 768px) {
        }
      `}</style>
    </>
  );
};

export default Collapsible;
